import { Provider } from '@angular/core';
import { PERSISTED_SLICES, PersistedSlice } from '../../oidc/store/persisted-state';
import * as newsFeature from './news.reducer';

export const provideNewsPersistence = (): Provider => ({
  provide: PERSISTED_SLICES,
  multi: true,
  useValue: {
    name: newsFeature.name,
    reshape: (stored: unknown): newsFeature.NewsState => {
      if(stored === null) {
        return newsFeature.initialState;
      }
      return stored as newsFeature.NewsState;
    },
  } satisfies PersistedSlice<newsFeature.NewsState>,
});
